<div class="bg-container mat-typography">
  <mat-icon class="logo" [svgIcon]="'tepra-logo'"></mat-icon>

  <div class="page-content">
    <div
      fxLayout="column"
      fxFlexAlign="center"
      class="fields-container-width primary-font successfully-container"
      ngClass.gt-md="lg"
      ngClass.md="md"
      ngClass.sm="sm"
      ngClass.xs="xs"
    >
      <div class="success-msg">
        <mat-icon class="icon-size">check_circle</mat-icon>
        <h2 class="primary-font title">{{ 'auth.successMsg1' | translate }}</h2>
        <h2 class="primary-font title">{{ 'auth.successMsg2' | translate }}</h2>
      </div>
    </div>
  </div>
</div>
